module.exports = __webpack_public_path__ + "static/img/namelist-icon.455481a3.png";